import React, { useState } from "react";
import DrawerFilter from "../../../components/listing/DrawerFilter";

export default function FiltroMarca({
  initialFilters = {},
  onSubmit = () => {},
  onClose = () => {},
}) {
  const [descricao, setDescricao] = useState(initialFilters.descricao || "");

  const handleApply = () => {
    onSubmit({ descricao: descricao.trim() });
    onClose();
  };

  return (
    <DrawerFilter
      title="Filtros de Marcas"
      onClose={onClose}
      onApply={handleApply}
    >
      <div>
        <label className="form-label-fil">Descripción:</label>
        <input
          type="text"
          className="input mt-1 w-full"
          value={descricao}
          onChange={(e) => setDescricao(e.target.value)}
          placeholder="Buscar por descripción..."
        />
      </div>
    </DrawerFilter>
  );
}